<template>
  <div style="display: none"></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { getStoredAffiliateCode } from '@/utils/affiliate'
import { myRequest } from '@/utils/fetch'
import { useAuthStore } from '@/stores/authStore'
import { useQuasar } from 'quasar'

interface APIError {
  response?: {
    status: number
  }
}

interface AffiliateResponse {
  success: boolean
  signup?: {
    id: number
    affiliateLinkId: number
    signedUpUserId: number
    createdAt: string
  }
  name?: string
}

const authStore = useAuthStore()
const $q = useQuasar()

/**
 * Track a successful signup from an affiliate link
 */
async function trackAffiliateSignup(): Promise<void> {
  const affiliateCode = getStoredAffiliateCode()

  // Only track if there's a stored affiliate code and the user is authenticated
  if (affiliateCode && authStore.isAuthenticated) {
    try {
      const response = (await myRequest('POST', `affiliate/track/signup/${affiliateCode}`)) as AffiliateResponse
      console.log('Affiliate signup tracked successfully')

      // Store the affiliate name if available
      if (response.name) {
        localStorage.setItem('affiliate_name', response.name)
      }

      // Clear the affiliate code after successful tracking
      localStorage.removeItem('affiliate_code')
      localStorage.removeItem('affiliate_first_visit')
    } catch (err: unknown) {
      console.error('Failed to track affiliate signup', err)

      // If the error is due to user already being assigned to an affiliate
      const apiError = err as APIError
      if (apiError?.response?.status === 409) {
        // Clear the affiliate code since it can't be used
        localStorage.removeItem('affiliate_code')
        localStorage.removeItem('affiliate_first_visit')

        // Show a user-friendly message
        $q.notify({
          type: 'info',
          message: 'You are already part of an affiliate program',
          timeout: 5000
        })
      }
    }
  }
}

onMounted(() => {
  // Track signup when component is mounted
  trackAffiliateSignup()
})
</script>
